<main>
  <pme-sdsn-shop-window *ngIf="this.classificationIdentifier === 'saude-do-seu-negocio'">
  </pme-sdsn-shop-window>
  <pme-consulta-shop-window *ngIf="this.classificationIdentifier === 'plano-mensal'"></pme-consulta-shop-window>
  <pme-monitore-shop-window *ngIf="this.classificationIdentifier === 'monitore-clientes'">
  </pme-monitore-shop-window>
  <pme-descomplica-shop-window *ngIf="this.classificationIdentifier === 'descomplica'"></pme-descomplica-shop-window>
</main>